import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import {
  MAP_LIST
} from '$http';
import $http from '$http';
import addPackageRule from './components/addPackageRule/index.vue'

export default {
  mixins: [services],
  components: {
    addPackageRule
  },
  data() {
    return {
      ProjectList: [{
        id: 1,
        name: "联帮在线"
      }, {
        id: 2,
        name: "HI幼教"
      }, {
        id: 4,
        name: "智趣坞"
      }],
      StatusType: [{
        id: 0,
        name: "未上架"
      }, {
        id: 1,
        name: "已上架"
      }, {
        id: 2,
        name: "已下架"
      }],
      tabName: '套餐规则详情',
      loading: false,
      lists: [],
      pageIndex: 1,
      pageSize: 10,
      totalSize: '',
      pageSizes: [10, 20, 50],
      query: this.getQuery(),
      RemarkMessage: '',
      RemarkdialogVisible: false,
      isPackageListShow: true, //套餐详情

    }
  },
  methods: {
    getQuery() {
      return cloneDeep({
        ProjectType: "",
        PackageName: "",
        PackageId: "",
        StandardAmount: "",
        SupportGoods: "",
        Status: "",
        ShelfTimeStart: "",
        ShelfTimeEnd: "",
      });
    },

    //搜索查询
    onQuerySubmit() {

      this.pageIndex = 1;
      this.getList();
    },
    //重置
    onQueryClean: function () {
      this.query = this.getQuery();
      this.getList();
    },
    tabChange(val) {
      if (val == '套餐规则详情') {
        this.isPackageListShow = true;
      } else {
        this.isPackageListShow = false;
      }
    },
    // 新增套餐规则
    addPackageRule() {
      this.$refs.refAddPackageRule.show({})
    },
    //查看备注
    handleView(index, row) {
      this.RemarkdialogVisible = true
      this.RemarkMessage = row.Remark
    },
    //修改
    editRule(index, row) {
      this.$refs.refAddPackageRule.show({
        id: row.Id,
        isChange: true
      })
    },

    handleCurrentChange: function (val) {
      this.pageIndex = val;
      this.getList();
    },
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.getList();
    },
  },
  created: function () {
    this.pageIndex = 1;
    this.getList();
  }

}


// WEBPACK FOOTER //
// ./src/pages/Memorandum/PackageRule/vm.js